import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthContext';

// API URL 설정
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// 출판물 페이지 컴포넌트
function Publication() {
  const { isAdmin } = useAuth();
  const [publications, setPublications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 데이터 가져오기
  useEffect(() => {
    fetchPublications();
  }, []);

  const fetchPublications = async () => {
    try {
      setLoading(true);
      const response = await fetch(`${API_URL}/publications`);
      const data = await response.json();

      if (data.success) {
        setPublications(data.data);
      } else {
        setError('Failed to load publications');
      }
    } catch (err) {
      console.error('Error fetching publications:', err);
      setError('Failed to connect to server');
    } finally {
      setLoading(false);
    }
  };

  // 카테고리 순서 정의 (표시할 카테고리만)
  const categoryOrder = [
    'International Conferences',
    'International Journals',
    'Domestic Conferences',
    'Domestic Journals',
    'Technical Reports',
    'Patents'
  ];

  // 카테고리별로 분류
  const categorizedPubs = {};
  categoryOrder.forEach(category => {
    categorizedPubs[category] = publications.filter(p => p.category === category);
  });

  // 날짜 포맷팅 함수
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const year = dateString.substring(0, 4);
    const month = dateString.substring(4, 6);
    const day = dateString.substring(6, 8);
    return `${year}${month}${day}`;
  };

  // 로딩 중
  if (loading) {
    return (
      <div className="site-content" style={{ textAlign: 'center', padding: '50px' }}>
        <p>Loading publications...</p>
      </div>
    );
  }

  // 에러 발생
  if (error) {
    return (
      <div className="site-content" style={{ textAlign: 'center', padding: '50px' }}>
        <p style={{ color: 'red' }}>{error}</p>
        <button onClick={fetchPublications}>Retry</button>
      </div>
    );
  }

  return (
    <div className="site-content">
      {/* 출판물 등록 버튼 - 관리자에게만 표시 */}
      {isAdmin && (
        <div style={{ textAlign: 'right', margin: '20px 0' }}>
          <Link to="/register-publication" style={{
            display: 'inline-block',
            padding: '8px 20px',
            backgroundColor: '#222',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '3px',
            fontSize: '14px',
            border: 'none'
          }}>
            Register an publication
          </Link>
        </div>
      )}

      {/* 카테고리별 출판물 */}
      {categoryOrder.map((category, index) => (
        categorizedPubs[category] && categorizedPubs[category].length > 0 && (
          <div key={category} style={{ marginBottom: '50px' }}>
            {/* 구분선 - 제목 위 (첫 번째 카테고리는 제외) */}
            {index > 0 && (
              <hr style={{ 
                margin: '50px 0 0 0', 
                border: 'none', 
                borderTop: '2px solid #333' 
              }} />
            )}
            
            <h2 style={{ 
              fontSize: '2rem', 
              fontWeight: 'bold', 
              margin: '20px 0 20px 0',
              borderBottom: 'none',
              paddingBottom: '0'
            }}>
              {category}
            </h2>
            <div style={{ margin: '20px 0', lineHeight: '2' }}>
              {categorizedPubs[category].map((pub) => (
                <div key={pub.ID} style={{ marginBottom: '15px', textAlign: 'left', display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                  <div style={{ flex: 1 }}>
                    <span style={{ color: '#555' }}>• </span>
                    <span>{pub.authors}</span>, 
                    <strong> "{pub.title}"</strong>
                    {pub.publisher && <span>, <em>{pub.publisher}</em></span>}
                    {pub.volume && <span>, Vol. {pub.volume}</span>}
                    {pub.issue && <span>, Issue {pub.issue}</span>}
                    {pub.pages && <span>, pp. {pub.pages}</span>}
                    {pub.location && <span>, {pub.location}</span>}
                    {pub.date && <span>, {formatDate(pub.date)}</span>}
                  </div>
                  {isAdmin && (
                    <Link 
                      to={`/edit-publication/${pub.ID}`}
                      style={{
                        padding: '4px 10px',
                        fontSize: '12px',
                        backgroundColor: '#0066cc',
                        color: '#fff',
                        textDecoration: 'none',
                        borderRadius: '3px',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      Edit
                    </Link>
                  )}
                </div>
              ))}
            </div>
          </div>
        )
      ))}

      {publications.length === 0 && (
        <p style={{ textAlign: 'center', color: '#666', marginTop: '50px' }}>
          No publications found.
        </p>
      )}
    </div>
  );
}

export default Publication;
